import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("txn_"), S.String).pipe(S.brand("@open-revenue/schema/stripe/BalanceTransactionId"), S.annotations({
    identifier: "@open-revenue/schema/stripe/BalanceTransactionId",
    description: "The id of the balance transaction in Stripe",
    examples: [
        "txn_1234567890"
    ]
}));
export const make = (balanceTransactionId)=>S.decodeUnknown(Schema)(balanceTransactionId);
export const makeUnsafe = (balanceTransactionId)=>balanceTransactionId;
